export enum WidgetTypes {
  IFRAME = 'IFRAME',
  IMAGE = 'IMAGE',
  SCRIPT = 'SCRIPT'
}
